export default "__VITE_ASSET__fa96dda5__"